import styled, { keyframes } from 'styled-components';
import { Rect } from 'dragonmouse-shared/geometry';
import { unthemed } from 'tokens';

interface BaseProps {
	sceneBounds: Rect;
	backgroundColor?: string;
}
export const Base = styled.div<BaseProps>`
	position: absolute;
	top: ${(p) => p.sceneBounds.y}px;
	left: ${(p) => p.sceneBounds.x}px;
	width: ${(p) => p.sceneBounds.width}px;
	height: ${(p) => p.sceneBounds.height}px;
	background: ${(p) => p.backgroundColor ?? unthemed.gray[900]};

	img,
	iframe {
		border: none;
		position: absolute;
		top: 0;
		left: 0;
	}
`;

export const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: ${unthemed.gray[900]}bb;
	overflow: hidden;
`;

export const CenterStack = styled.div`
	position: absolute;
	top: 45%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	pointer-events: none;
	width: 100%;
	padding: 0 16px;
	box-sizing: border-box;
`;

export const Percent = styled.div<{ size: number; isVisible: boolean }>`
	font-family: 'Inter', sans-serif;
	font-size: ${(p) => p.size}px;
	font-weight: 400;
	font-variant-numeric: tabular-nums;
	color: ${unthemed.gray[100]};
	margin-top: 18px;
	letter-spacing: 0.02em;
	line-height: 1;
	visibility: ${(p) => (p.isVisible ? 'visible' : 'hidden')};
`;

const textShimmer = keyframes`
	0% { background-position: 200% center; }
	100% { background-position: -200% center; }
`;

export const ShimmerCaption = styled.div<{ fontSize: number; marginTop: number }>`
	font-family: 'Inter', sans-serif;
	font-size: ${(p) => p.fontSize}px;
	font-weight: 400;
	line-height: 1.3;
	background: linear-gradient(
		90deg,
		${unthemed.gray[100]}55 0%,
		${unthemed.gray[100]}55 38%,
		${unthemed.gray[100]} 50%,
		${unthemed.gray[100]}55 62%,
		${unthemed.gray[100]}55 100%
	);
	background-size: 200% 100%;
	animation: ${textShimmer} 2.8s linear infinite;
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	color: transparent;
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
	margin-top: ${(p) => p.marginTop}px;
	max-width: 100%;
	text-align: center;
`;

// Static caption — same typography as ShimmerCaption but without the progress
// ripple. Used for terminal states (error) where no progress is being made.
export const Caption = styled.div<{ fontSize: number; marginTop: number }>`
	font-family: 'Inter', sans-serif;
	font-size: ${(p) => p.fontSize}px;
	font-weight: 400;
	line-height: 1.3;
	color: ${unthemed.gray[100]};
	display: -webkit-box;
	-webkit-line-clamp: 3;
	-webkit-box-orient: vertical;
	overflow: hidden;
	word-break: break-word;
	margin-top: ${(p) => p.marginTop}px;
	max-width: 100%;
	text-align: center;
`;

export const ErrorBlock = styled.div`
	position: absolute;
	top: 45%;
	left: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
`;

